import { FC } from 'react';
import { Field, FieldProps as FormikFieldProps, useFormikContext } from 'formik';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'mir-utils/i18n';
import { MAX_COMMENT_LENGTH } from 'mir-utils/consts';
import { IdecoTextField, IdecoTextFieldProps } from './IdecoTextField';

type FieldProps = Partial<IdecoTextFieldProps & FormikFieldProps['field']>;

/**
 * @summary Компонент IdecoTextField, обернутый в Field из Formik.
 *
 * @description Имеет счётчик введённых символов и параметры по умолчанию для единообразного отображения
 * поля комметария в формах.
 */
export const CommentField: FC<FieldProps> = (props) => {
  const { t } = useTranslation();
  const { values } = useFormikContext<any>();

  const DEFAULT_PROPS: FieldProps = {
    name: 'comment',
    label: t('Comment'),
    variant: 'outlined',
    multiline: true,
    minRows: 3,
    maxRows: 3,
  };

  const valueLength = values[props.name ?? 'comment'].length;

  return (
    <Stack>
      <Field component={IdecoTextField} {...DEFAULT_PROPS} {...props} style={{ width: '100%' }} />
      <Typography
        variant="caption"
        alignSelf="flex-end"
        pr={2}
        color={valueLength <= MAX_COMMENT_LENGTH ? 'textSecondary' : 'error'}
      >
        {`${valueLength}/${MAX_COMMENT_LENGTH}`}
      </Typography>
    </Stack>
  );
};
